import AppsContainer from "../../components/UmmIACategories/AppsContainer";
import HeaderCategoria from "../../components/UmmIACategories/HeaderCategoria";
import UmmIAClaseTitleImg from "../../components/UmmIACategories/img/UmmIAClaseTitleImg.png";

const UmmIAClasePage = () => {
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="UmmIAClase"
        descripcion="Aplicaciones para enriquecer tu trabajo en el aula"
        img={UmmIAClaseTitleImg}
        alt="Imagen UmmIA Clase"
        primaryColor="#BA4534"
        secondaryColor="#E3B5AE"
        thirdColor="#C86A5D"
      />

      {/* Contenedor de tarjetas: se renderizan solo las apps a las que el usuario tiene acceso */}
      <AppsContainer filter="UmmIAClase" />
    </>
  );
};

export default UmmIAClasePage;
